import { render } from "./SideBar.vue?vue&type=template&id=7b44c824"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SideBar.vue?vue&type=style&index=0&id=7b44c824&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__